export default "__VITE_ASSET__CLEjyPzT__"